/***
 * 盘谷打印
 */
import { pgMessage } from '../../message/index'
import { printTemplateCompile } from './print-template-compile'
import { sendPrint } from './jmreport'

export async function browserex({ compileDatas, printTemplate }) {
  const { printTemplateContents } = await printTemplateCompile({
    printTemplate,
    compileDatas,
    html: true,
  })
  if (!printTemplateContents?.length) {
    pgMessage.error(`因数量为零的数据已过滤,目前无打印数据~`)
    return Promise.reject()
  }

  return sendPrint({
    compileDatas: printTemplateContents,
    printTemplate,
    url: '/api/jimu/print',
    getParam: (content) => {
      return {
        Body: content.content,
      }
    },
  })
}
